export const environment = {
  production: true,
  apiUrl: 'https://api.technicalwater.app',
  baseDomainUrl: 'https://mobile.technicalwater.app/',

  // # secret
  JWT_ACCESS_SECRET: 'twmssServerSecret',
  JWT_REFRESH_SECRET: 'twmssServerRefreshSecret',
  JWT_LOGIN_SECRET: 'twmssServerLoginSecret',

  sentry: {
    enable: true,
    environment: 'production',
    dsn: 'https://16226cdc3c92102383073aabcc05412f@o4510305351106560.ingest.us.sentry.io/4510306426421248',
    tracesSampleRate: 0.1,
  },
};
